import React, { useState, useEffect } from 'react';
import properties from '../../../modules/ajio-util/properties';
import { IsDealEnd } from './DodComponentFunctionality';

const imageBaseUrl = properties.getProperty('imageBaseUrl');

export const DealOfTheDayTag = () => {
  return <p className="dealOfDay__tag">DEAL OF THE DAY</p>;
};
export let dodTimerId = '';
export const DealOfTheDayProductTimer = React.memo(props => {
  const {
    dealOfTheDayProductTimer = '',
    topTimerOrProductTimer = false,
    imagePath = '',
    modalName = '',
    isCartTimeOut = false,
    isPdpMsite = false,
    showDodModal = '',
    deviceType = ''
  } = props;
  const timer = IsDealEnd(dealOfTheDayProductTimer);
  const [timerCounter, handleTimeChange] = useState(timer);
  const { hr = '', mins = '', secs = '' } = timerCounter;
  const updateTimer = (hr, mins, secs) => {
    const secInt = parseInt(secs);
    const minInt = parseInt(mins);
    const hourInt = parseInt(hr);
    if (hourInt <= 0 && minInt <= 0 && secInt <= 0) {
      topTimerOrProductTimer && props.showModal && props.showModal(modalName);
      isCartTimeOut && props.showModal && props.showModal(modalName);
      isPdpMsite && props.showModal && props.showModal(modalName);
      if (deviceType === 'mobile' && typeof showDodModal === 'function') {
        showDodModal();
      }
      // return true;
      handleTimeChange(prevState => {
        return {
          ...prevState,
          secs,
          mins,
          hr
        };
      });
    }
    secs = `${secInt}`.padStart(2, '0');
    mins = `${minInt}`.padStart(2, '0');
    hr = `${hourInt}`.padStart(2, '0');
    handleTimeChange(prevState => {
      return {
        ...prevState,
        secs,
        mins,
        hr
      };
    });
  };

  const startTimer = () => {
    dodTimerId = setInterval(() => {
      const timer = IsDealEnd(dealOfTheDayProductTimer);
      const { hr = '', mins = '', secs = '', isDealEnd } = timer;
      const isOver = updateTimer(hr, mins, secs);
      isDealEnd && isOver && clearInterval(dodTimerId);
    }, 1000);
  };

  // useEffect(() => updateTimer(hr, mins, secs), [secs]);
  useEffect(startTimer, []);

  let timerDOM = topTimerOrProductTimer ? (
    <p aria-label={`${hr}h ${mins}m ${secs}s`}>
      <span>{hr}</span>h<span>{mins}</span>m<span>{secs}</span>s
    </p>
  ) : (
    <p aria-label={`${hr}h ${mins}m ${secs}s`}>
      <span>{hr}h</span>: <span>{mins}m</span>: <span>{secs}s</span>
    </p>
  );
  if (deviceType === 'mobile') {
    timerDOM = (
      <p aria-label={`${hr}h ${mins}m ${secs}s`}>
        <span>{hr}</span>h&nbsp;<span>{mins}</span>m&nbsp;<span>{secs}</span>s
      </p>
    );
  }
  const imgDom =
    imagePath && !topTimerOrProductTimer ? (
      <div className="dodProductTimer">
        <img src={imageBaseUrl + imagePath} alt="" />{' '}
      </div>
    ) : (
      ''
    );
  return (
    <div className="dealOfDay__timer--counter">
      {imgDom}
      {timerDOM}
    </div>
  );
});

export const DealOfTheDayTimerTag = React.memo(props => {
  const {
    isStartIn = false,
    isStartInWithoutColon = false,
    dealOfTheDayProductTimer = '',
    topTimerOrProductTimer = false,
    imagePath = '',
    modalName = '',
    isCartTimeOut = false,
    isPdpMsite = false,
    deviceType = '',
    showDodModal = '',
    isNewPdpMiste = false,
    isNewCartMsite = false,
    alt = ''
  } = props;
  let timerHeaderProduct = isStartIn ? 'Starts in :' : 'Ends in :';
  let timerHeaderTop = isStartInWithoutColon ? 'Starts in ' : 'Ends in ';
  if (deviceType === 'mobile') {
    timerHeaderProduct = 'Deal ends in';
    timerHeaderTop = isStartInWithoutColon ? 'Deal Starts in ' : 'Deal Ends in: ';
  }
  const finalHeader = topTimerOrProductTimer ? timerHeaderTop : timerHeaderProduct;
  return (
    <div className="dealOfDay__timer">
      {isNewPdpMiste ||
        (isNewCartMsite && (
          <div className="dodProductTimer">
            <img src={imageBaseUrl + imagePath} alt={alt || 'Timer icon'} />
          </div>
        ))}
      <span className="dealOfDay__timer--header" aria-label={finalHeader}>
        {finalHeader}&nbsp;&nbsp;
      </span>
      <DealOfTheDayProductTimer
        dealOfTheDayProductTimer={dealOfTheDayProductTimer}
        topTimerOrProductTimer={topTimerOrProductTimer}
        showModal={props.showModal}
        imagePath={imagePath}
        modalName={modalName}
        isCartTimeOut={isCartTimeOut}
        isPdpMsite={isPdpMsite}
        showDodModal={showDodModal}
        deviceType={deviceType}
        isNewPdpMiste={isNewPdpMiste}
      />
    </div>
  );
});
